(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("lego-components", ["react"], factory);
	else if(typeof exports === 'object')
		exports["lego-components"] = factory(require("react"));
	else
		root["lego-components"] = factory(root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 